import { render } from "./Import.vue?vue&type=template&id=3cb608dd&scoped=true"
import script from "./Import.vue?vue&type=script&lang=js"
export * from "./Import.vue?vue&type=script&lang=js"

import "./Import.vue?vue&type=style&index=0&id=3cb608dd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3cb608dd"

export default script